module.exports = __webpack_public_path__ + "img/img_web_2.4240276c.jpg";